

    import SelectAnswerTypeSelector from './common/SelectAnswerTypeSelector.vue'
    import StepContainer from './common/StepContainer.vue'
    import ContentDisplayClosed from './common/ContentDisplayClosed.vue'
    import Vue from 'vue'
    import RatingScaleSelector from './common/RatingScaleSelector.vue'
    import RepeatingStepLogic from './common/RepeatingStepLogic'
    import HelperMethods from './common/HelperMethods'
    import TipsSelector from './common/TipsSelector.vue'
    import TextInputButton from './common/TextInputButton.vue'
    import TextAreaButton from './common/TextAreaButton.vue'
    import Checkbox from './common/Checkbox.vue'

    export default Vue.extend({
        //--------
        data () {
            return {
            }
        },
        //--------
        mixins: [RepeatingStepLogic, HelperMethods],
        //--------
        created (): void {   
            
        },
        //---------
        props: {
            compIndex: Number
        },
        //--------
        components: {
            surveystep: StepContainer,
            ContentDisplayClosed,
            TipsSelector,
            SelectAnswerTypeSelector,
            RatingScaleSelector,
            TextAreaButton,
            TextInputButton,
            Checkbox
        },
        computed: {
        },
        //--------
        methods: {
        }
    })
